import { render } from "./About.vue?vue&type=template&id=743310cf&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=743310cf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-743310cf"

export default script